// components/Footer.js
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 mt-[5%]">
    <div className="container mx-auto px-6 flex flex-col md:flex-row md:justify-between md:items-start">
        
        <div className="text-center md:text-left mb-6 md:mb-0">
          <h4 className="text-lg font-semibold">officialbillboard</h4>
          <p className="text-sm mt-1">Crypto investing evolved through insight</p>
        </div>

        <div className="text-center md:text-right mb-6 md:mb-0 flex flex-col items-center justif-center">
          <p className="text-sm font-semibold">Trading Hours:</p>
          <p className="text-sm">Monday - Friday: 9 AM - 5 PM (UTC)</p>
        </div>

        <div className="text-center mb-6 md:mb-0 flex flex-col items-center justify-center">
          <h5 className="text-lg font-semibold mb-2">Contact Us</h5>
          <p className="text-sm">
            Email: <a href="mailto:" className="text-blue-500 hover:underline">officialbillboard@officialbillboard.com</a>
          </p>
          <p className="text-sm">
            WhatsApp: <a href="https://wa.me/17278333823" className="text-blue-500 hover:underline">+1(727) 833-3823</a>
          </p>
          <p className="text-sm">Address: Austin, Texas</p>
        </div>
      </div>

      <div className="bg-gray-800 p-6 rounded-lg mt-8 flex flex-col items-center justify-center">
        <h5 className="text-lg font-semibold mb-2">⚠️ Important Warning</h5>
        <p className="text-sm">
          Investing in cryptocurrency involves a high degree of risk. Prices can be extremely volatile, and past performance is not indicative of future results. Please invest responsibly and seek advice from a qualified financial advisor.
        </p>
      </div>
      <div className="text-center mt-6">
        <p className="text-sm">&copy; {new Date().getFullYear()} officialbillboard. All rights reserved.</p>
      </div>
    </footer>
  );
};
export default Footer;

